import React, { useState } from 'react';
import styled from 'styled-components';

import { BrandedContent } from 'homepage/components/brandView/BrandedContent';
import { BrandSpaceContent } from 'homepage/components/brandView/BrandSpaceContent';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { SECTION_TYPES } from 'homepage/enums/contentConstants';
import { usePutBackHeaderOnPageChange, useToggleHeaderOnScrollEvent } from 'shared/hooks';
import { useVideoLazyLoad } from 'homepage/hooks/useVideoLazyLoad';
import { WRAPPER, NUM_OF_COLUMNS, MOBILE_NUM_OF_COLUMNS } from 'homepage/styles/constants';

import { IFeedHeroSection } from 'homepage/types/Feed';
import { ISpaceArticleSection } from 'shared/types/SpaceArticleSection';

/**
 * [BrandedContentContainer]
 *  displays a simulated random assortment of branded assets (image & video)
 * @param {Object} heroes A list heroes to be split into groups of 4.
 */

interface IBrandedContentContainer {
  heroes: (IFeedHeroSection | ISpaceArticleSection)[] | [];
  noTopMargin?: boolean;
  drawerName?: string;
}

export const BrandedContentContainer = ({
  heroes,
  noTopMargin = false,
  drawerName = '',
}: IBrandedContentContainer) => {
  useVideoLazyLoad();
  useToggleHeaderOnScrollEvent(true);
  usePutBackHeaderOnPageChange();

  const [firstVideo, setIsFirstVideo] = useState(null);

  return (
    <BrandedContentContainer.Wrapper $noTopMargin={noTopMargin}>
      {heroes?.map((item, index) =>
        item?.type === SECTION_TYPES.SPACE_ARTICLE_SECTION ? (
          <BrandSpaceContent drawerName={drawerName} key={item?.id} section={item} />
        ) : (
          <BrandedContent
            key={item?.id}
            drawerName={drawerName}
            {...item}
            index={index}
            firstVideo={firstVideo}
            setFirstVideo={setIsFirstVideo}
          />
        ),
      )}
    </BrandedContentContainer.Wrapper>
  );
};

BrandedContentContainer.Wrapper = styled.div<{ $noTopMargin: boolean }>`
  ${({ $noTopMargin }) => $noTopMargin && `margin-top: 56px`};
  width: ${WRAPPER};
  display: grid;
  max-width: 100vw;

  min-height: 100vh;
  overflow: hidden;

  grid-template-columns: repeat(${MOBILE_NUM_OF_COLUMNS}, 1fr);
  grid-auto-flow: dense;
  grid-auto-rows: auto;
  grid-gap: 0px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    grid-template-columns: repeat(${NUM_OF_COLUMNS}, 1fr);
    grid-auto-flow: dense;
    grid-auto-rows: auto;
    grid-gap: 0px;
  }

  ${hideScrollbars}
`;
